export default __webpack_public_path__ + "static/media/privacy.35a868f9.svg";